import { keyframes } from "@emotion/react";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import ChatBubble from "./ChatBubble";

interface TypingIndicatorProps {
  name?: string;
}

const typingPulse = keyframes`
  0%, 60%, 100% { transform: translateY(0) scale(0.8); opacity: 0.35; }
  30% { transform: translateY(-4px) scale(1); opacity: 1; }
`;

const typingFade = keyframes`
  0%, 60%, 100% { opacity: 0.35; }
  30% { opacity: 1; }
`;

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ name }) => (
  <ChatBubble senderName={name} paperSx={{ minWidth: "60px", p: 1.5 }}>
    <Stack direction="row" spacing={1} alignItems="center" role="status" aria-live="polite" aria-label={`${name ?? "Randol"} is responding`}>
      <Typography variant="caption">{name ?? "Randol"} is responding...</Typography>
      <Stack direction="row" spacing={0.5} aria-hidden="true" sx={{ flexShrink: 0, py: 0.5 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: "primary.main",
              animation: `${typingPulse} 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.16}s`,
              "@media (prefers-reduced-motion: reduce)": { animation: `${typingFade} 1.8s ease-in-out infinite`, animationDelay: `${i * 0.24}s` },
            }}
          />
        ))}
      </Stack>
    </Stack>
  </ChatBubble>
);

export default TypingIndicator;
